// Core
import React, { Component } from 'react';
import { CircleCheck, CircleAlert } from 'lucide-react';

// Components
import {rules, titles, validators} from './policy';

export default class PasswordPolicy extends Component {

    /**
     * Does every rule pass
     * 
     */
    static every(value)
    {
        const result = PasswordPolicy.runAllValidators(value);
        return Object.values(result).every(Boolean);
    }

    /**
     * Does any of the rules pass
     *
     */
    static any(value)
    {
        const result = PasswordPolicy.runAllValidators(value);
        return Object.values(result).some(Boolean);
    }

    static runAllValidators(value)
    {
        return rules.reduce((accumulator, rule) => {
            const is_valid = PasswordPolicy.runValidator(rule, value);

            return Object.assign(accumulator, {[rule]: is_valid});
        }, {});
    }

    static runValidator(validator_key, value)
    {
        if (!validators[validator_key]) {
            return false;
        }

        const validator = validators[validator_key];
        return validator(value);
    }

    renderChecklist(source = rules, value)
    {
        return source.map((rule, key) => {
            const is_valid = PasswordPolicy.runValidator(rule, value);

            return this.renderItem(rule, is_valid);
        })
    }

    renderItem(rule_key, pass = false)
    {
        const rule_marked = (pass ? 'rule_pass' : 'rule_not_passed');
        const rule_name = 'rule_key_' + rule_key.toLowerCase();

        const rule_classnames = [rule_name, rule_marked].join(' ');
        const textColorClass = pass ? 'text-emerald-700' : 'text-muted-foreground';

        const IconComponent = pass ? CircleCheck : CircleAlert;

        return (
            <div key={rule_key} className={'flex items-center gap-2 text-xs password_policy_rule ' + rule_classnames}>
                <IconComponent className={`size-4 ${textColorClass} transition-colors duration-300`}/>
                <div className={`rule_label ${textColorClass} transition-colors duration-300`}>
                    {titles[rule_key]}
                </div>
            </div>
        )
    }

    render() {
        return (
            <div className="flex flex-col gap-1">
                <span className="text-xs text-foreground font-medium mb-2">Your password must contain:</span>
                {this.renderChecklist(rules, this.props.value)}
            </div>
        )
    }
}

PasswordPolicy.defaultProps = {
    value: '',
}